import styled from "styled-components";
import { NavLink } from "react-router";
import type { ReactNode } from "react";

/**
 * [共通パーツ]メニューアイテム
 */

type Props = {
  to: string;
  children: ReactNode;
};

const StyledMenuItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-left: 20px;
  margin-right: 20px;
  height: 60px;
  cursor: pointer;
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;
  height: 100%;
  display: flex;
  align-items: center;
  &.active {
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      border-bottom: 4px solid ${(props) => props.theme.colors.brand};
    }
  }
`;

export function MenuItem({ to, children }: Props) {
  return (
    <StyledMenuItem>
      <StyledNavLink to={to}>{children}</StyledNavLink>
    </StyledMenuItem>
  );
}
